import {
  FETCH_DS1_BRAND_LIST,
  RESET_DS1_BRAND_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const ds1BrandListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DS1_BRAND_LIST:
      return { list: action.payload, others: action.others };
    case RESET_DS1_BRAND_LIST: {
      return initialState;
    }
    default:
      return state;
  }
};

export default ds1BrandListReducer;
